import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronsRight: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm6 17 5-5-5-5' }],
    ['path', { d: 'm13 17 5-5-5-5' }],
  ],
];

export default ChevronsRight;
